import {Pipe, PipeTransform} from '@angular/core';
@Pipe ({
   name : 'Status'
})
export class Status implements PipeTransform {
   transform(val: string): string {

    switch (val) {
        case 'INTRANSIT': return 'In Transit';
        case 'PICKEDUP': return 'Picked Up';
        case 'RECEIVED': return 'Received';
        case 'REMOVINGDATABEARINGDEVICES': return 'Removing Data Bearing Devices';
        case 'INMANIFEST': return 'In Manifest';
        case 'INTESTING': return 'In Testing';
        case 'INSALES': return 'In Sales';
        case 'PROCESSED': return 'Processed';
    }

    return val;
   }
}